import useLandingPageStore from '@shared/stores/useLandingPageStore.js'
import useSharedStore from '@shared/stores/useSharedStore.js'

const normalizeSlugWithCampaign = (raw) => {
  if (!raw) return { slug: '', campaign: '' }
  const value = `${raw}`.toLowerCase()
  if (!value.includes('.')) return { slug: value, campaign: '' }
  const [slug, campaign] = value.split('.')
  return { slug, campaign: campaign || '' }
}

const applyCampaign = (query, campaign) => {
  if (campaign) query.set('utm_campaign', campaign)
}

const updateInitialPathAndQueryWithTrackingData = async () => {
  // Normalize landing page slug from query/path (including dot notation) and then
  // apply landing-page owned tracking params before tracker/router init.
  const landingPageStore = useLandingPageStore()
  const sharedStore = useSharedStore()

  const query = new URLSearchParams(window.location.search)
  const path = window.location.pathname.split('/')

  const { slug: querySlug, campaign: queryCampaign } =
    normalizeSlugWithCampaign(query.get('corporate'))
  const { slug: pathSlug, campaign: pathCampaign } = normalizeSlugWithCampaign(
    path[1],
  )

  applyCampaign(query, pathCampaign || queryCampaign)

  if (querySlug && !path[1]) {
    path[1] = querySlug
    query.delete('corporate')
  } else if (querySlug) {
    query.set('corporate', querySlug)
  }

  if (pathSlug) {
    path[1] = pathSlug
  }

  let landingPage
  try {
    landingPage = await landingPageStore.ensureLandingPage(
      querySlug || pathSlug,
    )
  } catch {
    landingPage = null
  }

  if (!landingPage) {
    // Landing page failed to load; store the query as derived from the URL only.
    sharedStore.storeInitialQuery(Object.fromEntries(query.entries()))
  } else {
    if (landingPage.trackingParams) {
      Object.entries(landingPage.trackingParams).forEach(([key, value]) => {
        query.set(key, value?.toString?.() ?? '')
      })
    }

    sharedStore.storeInitialQuery(Object.fromEntries(query.entries()))
  }
  const queryString = query.toString()
  const url = `${path.join('/')}${queryString ? `?${queryString}` : ''}${
    window.location.hash
  }`
  window.history.replaceState({}, '', url)
}

export default updateInitialPathAndQueryWithTrackingData
